import script from "./ClaimRings.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimRings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__